import LazyLoad from  'lazyload'
export default function() {
	var lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));
	new LazyLoad(lazyImages, {
		root: null,
		rootMargin: "0px",
		threshold: 0
	});
}